(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-search"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const searchInput = document.getElementById('tas-search-input');

    if (searchInput) {
      // Handle input focus states
      searchInput.addEventListener('focus', function () {
        this.closest('.tas-search-form__wrapper').style.borderColor = '#D73B3B';
      });

      searchInput.addEventListener('blur', function () {
        this.closest('.tas-search-form__wrapper').style.borderColor = '#E5E5E5';
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-tas"] && !Shopify.designMode) return;
  try {
    
  console.log('[HEADER] JavaScript block is loading...');

  // Add Shopify money format
  if (typeof Shopify === 'undefined') {
    var Shopify = {};
  }

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    // Use String.fromCharCode to avoid Liquid interpreting {{ }}
    var openBrace = String.fromCharCode(123, 123); // {{
    var closeBrace = String.fromCharCode(125, 125); // }}
    var placeholderRegex = new RegExp(openBrace + '\\s*(\\w+)\\s*' + closeBrace);
    var formatString = format || '$' + openBrace + 'amount' + closeBrace;

    function defaultOption(opt, def) {
      return typeof opt == 'undefined' ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('.predictive-search__results-list');
      this.loadingState = this.querySelector('.predictive-search-status');
      this.predictiveSearch = this;
      this.form = this.querySelector('form');

      // Get current locale for translation support
      this.currentLocale = document.documentElement.lang || 'en';
      console.log('PredictiveSearch initialized with locale:', this.currentLocale);

      // Enhanced rate limiting and circuit breaker
      this.lastRequestTime = 0;
      this.minRequestInterval = 1000; // Increased to 1 second minimum between requests
      this.activeRequests = 0;
      // Allow one in-flight request plus one follow-up request from rapid input/focus events.
      this.maxConcurrentRequests = 2;
      this.rateLimitCount = 0; // Track consecutive 429 errors
      this.backoffDelay = 1000; // Start with 1 second backoff
      this.maxBackoffDelay = 10000; // Max 10 seconds
      this.isCircuitOpen = false; // Circuit breaker
      this.circuitResetTime = 0;
      this.circuitTimeout = 30000; // 30 seconds before attempting to reset circuit

      // Debouncing
      this.searchTimeout = null;
      this.debounceDelay = 300; // 300ms debounce

      // Storefront API configuration for fetching brand IDs.
      // Read from data-* attributes because this code lives in a {% javascript %}
      // block that Shopify compiles into scripts.js without Liquid rendering.
      this.storefrontAccessToken = this.dataset.storefrontToken || '';
      this.shopDomain = this.dataset.shopDomain || '';
      this.storefrontApiUrl = `https://${this.shopDomain}/api/2024-01/graphql.json`;

      // Custom Product Index – replaces the MPN-only sidecar with a full index
      // supporting SKU, MPN, Barcode, Family ID, and any configured metafields.
      this.customIndexUrl = this.dataset.customIndexUrl || 'https://texasartsupply-cpi.vercel.app';
      // Cached set of product handles already returned by the custom index so we
      // don't fetch brand IDs / discontinued status for those via Storefront API.
      this._customIndexHandles = new Set();

      // Translation strings based on locale
      this.translations = this.getTranslations();

      this.setupEventListeners();
    }

    getTranslations() {
      // Get translations from the global variable set by Liquid
      const globalTranslations = window.predictiveSearchTranslations || {};

      const translations = {
        seeAllProducts: globalTranslations.seeAllProducts || 'See All Products',
        collections: globalTranslations.collections || 'Collections',
        pages: globalTranslations.pages || 'Pages',
        articles: globalTranslations.articles || 'Articles',
        products: globalTranslations.products || 'Products',
        brand: globalTranslations.brand || 'Brand',
        shopBrand: globalTranslations.shopBrand || 'Shop',
        searchingExact:
          this.currentLocale === 'es'
            ? 'Buscando coincidencias exactas por SKU, etiquetas de ID de familia y MPN...'
            : 'Searching for exact matches by SKU, Family ID tags, and MPN...',
        searchTemporarilyDisabled:
          this.currentLocale === 'es'
            ? 'Búsqueda temporalmente deshabilitada. Intenta de nuevo en un momento.'
            : 'Search temporarily disabled. Try again in a moment.',
        searchDisabledServer:
          this.currentLocale === 'es'
            ? 'Búsqueda temporalmente deshabilitada debido a limitaciones del servidor. Intenta de nuevo en 30 segundos.'
            : 'Search temporarily disabled due to server limitations. Try again in 30 seconds.',
        tooManyRequests:
          this.currentLocale === 'es'
            ? 'Demasiadas solicitudes. Por favor, espera un momento antes de intentar de nuevo.'
            : 'Too many requests. Please wait a moment before trying again.',
        searchError:
          this.currentLocale === 'es'
            ? 'Error al buscar productos. Por favor, intenta de nuevo.'
            : 'Error searching for products. Please try again.',
      };

      console.log('Loaded translations:', translations);
      return translations;
    }

    setupEventListeners() {
      this.input?.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300)
      );

      this.input?.addEventListener('focus', this.onFocus.bind(this));
      document.addEventListener('click', this.onDocumentClick.bind(this));

      // Handle form submission
      this.form?.addEventListener('submit', (event) => {
        // Only prevent default if we have active search results and a result is selected
        const isExpanded = this.input.getAttribute('aria-expanded') === 'true';
        const selectedResult = this.results.querySelector('.predictive-search__link:focus');

        if (isExpanded && selectedResult) {
          event.preventDefault();
          selectedResult.click();
        } else {
          // Allow normal form submission for regular search
          return true;
        }
      });

      // Handle keyboard navigation
      this.input?.addEventListener('keydown', (event) => {
        switch (event.key) {
          case 'ArrowUp':
            event.preventDefault();
            this.navigateResults('up');
            break;
          case 'ArrowDown':
            event.preventDefault();
            this.navigateResults('down');
            break;
          case 'Enter':
            // Only prevent default if we have a result selected
            const selectedResult = this.results.querySelector('.predictive-search__link:focus');
            if (selectedResult) {
              event.preventDefault();
              selectedResult.click();
            }
            break;
          case 'Escape':
            this.close();
            break;
        }
      });
    }

    navigateResults(direction) {
      const links = Array.from(this.results.querySelectorAll('.predictive-search__link'));
      if (!links.length) return;

      const currentIndex = links.findIndex((link) => document.activeElement === link);
      let nextIndex;

      if (direction === 'up') {
        nextIndex = currentIndex > 0 ? currentIndex - 1 : links.length - 1;
      } else {
        nextIndex = currentIndex < links.length - 1 ? currentIndex + 1 : 0;
      }

      // If no current selection, start from the beginning
      if (currentIndex === -1) {
        nextIndex = direction === 'up' ? links.length - 1 : 0;
      }

      links[nextIndex].focus();
    }

    onChange(event) {
      const searchTerm = event.target.value.trim();

      // Clear any existing search timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }

      if (searchTerm.length === 0) {
        this.close();
        return;
      }

      // Minimum 3 characters required before searching
      if (searchTerm.length < 3) {
        this.close();
        return;
      }

      // Debounce the search to prevent rapid API calls
      this.searchTimeout = setTimeout(() => {
        this.getSearchResults(searchTerm);
      }, this.debounceDelay);
    }

    onFocus() {
      const searchTerm = this.input.value.trim();
      // Minimum 3 characters required before searching
      if (searchTerm.length < 3) return;
      this.getSearchResults(searchTerm);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.close();
      }
    }

    close() {
      this.input.setAttribute('aria-expanded', 'false');
      this.classList.remove('predictive-search--loading');
      this.results.style.display = 'none';
    }

    async checkMpnMatch(searchTerm) {
      // ── Custom Product Index ──────────────────────────────────────────────
      // Queries the full Custom Product Index which handles SKU, MPN, Barcode,
      // Family ID, and any configured metafields.
      // Legacy shopsearch sidecar has been intentionally removed.
      const indexUrl = (this.customIndexUrl || '').trim().replace(/\/+$/, '');
      if (!indexUrl) return [];

      try {
        const fetchMatches = async (q, reason = 'primary') => {
          const response = await fetch(`${indexUrl}/api/cpi/search?q=${encodeURIComponent(q)}`);
          if (!response.ok) {
            console.warn(`[CustomIndex] Non-OK response (${reason}):`, response.status);
            return [];
          }
          const raw = await response.json();
          const matches = Array.isArray(raw) ? raw : [];
          console.log(`[CustomIndex] Returned (${reason}):`, matches);
          return matches;
        };

        let matches = await fetchMatches(searchTerm, 'primary');

        // Retry with a normalized form for MPN/SKU values that may contain spaces/dashes.
        if (!matches.length) {
          const normalized = (searchTerm || '').replace(/[^A-Z0-9]/gi, '').toUpperCase();
          const originalNormalized = (searchTerm || '').toUpperCase();
          if (normalized && normalized !== originalNormalized) {
            matches = await fetchMatches(normalized, 'normalized');
          }
        }

        // Track which handles came from the index so we can skip redundant API calls
        this._customIndexHandles = new Set((matches || []).map((m) => m.productHandle || m.handle).filter(Boolean));
        return matches;
      } catch (error) {
        console.error('[CustomIndex] Error:', error);
        return [];
      }
    }

    // Filter out products where all variants are discontinued
    async filterDiscontinuedProducts(products, searchTerm = '') {
      if (!products || products.length === 0 || !this.storefrontAccessToken) {
        return products;
      }

      try {
        // Extract product handles from URLs
        const productHandles = products
          .map((product) => {
            if (product.handle) return product.handle;
            if (product.url) {
              const match = product.url.match(/\/products\/([^?]+)/);
              return match ? match[1] : null;
            }
            return null;
          })
          .filter(Boolean);

        if (productHandles.length === 0) {
          return products;
        }

        console.log('[DISCONTINUED] Checking discontinued status for handles:', productHandles);

        const normalizedSearchTerm = searchTerm.trim();
        const shouldCheckExactSku = /^\d{5}$/.test(normalizedSearchTerm);

        // Build GraphQL query to get all variants with discontinued metafield
        // Query up to 10 products at a time for performance
        const handlesToQuery = productHandles.slice(0, 10);

        const query = `{
          ${handlesToQuery
            .map(
              (handle, index) => `
            product${index}: productByHandle(handle: "${handle}") {
              handle
              variants(first: 100) {
                edges {
                  node {
                    id
                    sku
                    discontinued: metafield(namespace: "custom", key: "discontinued") {
                      value
                    }
                  }
                }
              }
            }
          `
            )
            .join('')}
        }`;

        const response = await fetch(this.storefrontApiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
          },
          body: JSON.stringify({ query }),
        });

        if (!response.ok) {
          console.log('[DISCONTINUED] Storefront API request failed:', response.status);
          // If the API fails, return all products (fail open)
          return products;
        }

        const data = await response.json();

        if (data.errors) {
          console.log('[DISCONTINUED] GraphQL errors:', data.errors);
          // If there are errors, return all products (fail open)
          return products;
        }

        console.log('[DISCONTINUED] Storefront API response:', data);

        // Build a map of product handles to their discontinued status
        const productDiscontinuedMap = new Map();

        handlesToQuery.forEach((handle, index) => {
          const productData = data.data[`product${index}`];
          if (productData && productData.variants) {
            const variants = productData.variants.edges.map((edge) => edge.node);

            // Check if ALL variants are discontinued
            const allDiscontinued = variants.every((variant) => {
              const discontinuedValue = variant.discontinued?.value;
              return discontinuedValue === 'true' || discontinuedValue === true;
            });

            // Check if there's at least one non-discontinued variant
            const hasAvailableVariant = variants.some((variant) => {
              const discontinuedValue = variant.discontinued?.value;
              return !discontinuedValue || (discontinuedValue !== 'true' && discontinuedValue !== true);
            });

            // Check for an exact SKU match from Storefront data.
            // This catches cases where predictive search omits variant SKUs.
            let exactSkuVariantIndex = -1;
            if (shouldCheckExactSku) {
              exactSkuVariantIndex = variants.findIndex((variant) => {
                const variantSku = (variant.sku || '').trim();
                return variantSku === normalizedSearchTerm;
              });
            }

            productDiscontinuedMap.set(productData.handle, {
              allDiscontinued,
              hasAvailableVariant,
              variantCount: variants.length,
              exactSkuVariantIndex,
            });

            if (allDiscontinued) {
              console.log(`[DISCONTINUED] Product "${productData.handle}" has all variants discontinued`);
            } else {
              console.log(`[DISCONTINUED] Product "${productData.handle}" has available variants`);
            }
          }
        });

        // Filter out products where all variants are discontinued
        const filteredProducts = products.filter((product) => {
          const handle = product.handle || (product.url ? product.url.match(/\/products\/([^?]+)/)?.[1] : null);

          if (!handle) {
            // If we can't determine the handle, keep the product (fail open)
            return true;
          }

          const discontinuedInfo = productDiscontinuedMap.get(handle);

          if (!discontinuedInfo) {
            // If we don't have discontinued info, keep the product (fail open)
            return true;
          }

          // Persist exact SKU match metadata for downstream badge rendering.
          if (discontinuedInfo.exactSkuVariantIndex !== undefined && discontinuedInfo.exactSkuVariantIndex >= 0) {
            product._hasExactSkuMatch = true;
            product._storefrontExactSku = normalizedSearchTerm;
          }

          // Only keep products that have at least one available variant
          return discontinuedInfo.hasAvailableVariant;
        });

        const removedCount = products.length - filteredProducts.length;
        if (removedCount > 0) {
          console.log(`[DISCONTINUED] Filtered out ${removedCount} products with all variants discontinued`);
        }

        return filteredProducts;
      } catch (error) {
        console.log('[DISCONTINUED] Error filtering discontinued products:', error);
        // If there's an error, return all products (fail open)
        return products;
      }
    }

    // Fetch brand IDs for products using Storefront API
    async fetchBrandIdsForProducts(products) {
      if (!products || products.length === 0 || !this.storefrontAccessToken) {
        return products;
      }

      try {
        // Extract product handles from URLs
        const productHandles = products
          .map((product) => {
            if (product.handle) return product.handle;
            if (product.url) {
              const match = product.url.match(/\/products\/([^?]+)/);
              return match ? match[1] : null;
            }
            return null;
          })
          .filter(Boolean);

        if (productHandles.length === 0) {
          return products;
        }

        // Build GraphQL query for multiple products (up to 10 for full result coverage)
        const handlesToQuery = productHandles.slice(0, 10);

        console.log('[BRAND] Querying Storefront API for handles:', handlesToQuery);

        const query = `{
          ${handlesToQuery
            .map(
              (handle, index) => `
            product${index}: productByHandle(handle: "${handle}") {
              handle
              metafield(namespace: "custom", key: "product_brand_id") {
                value
              }
            }
          `
            )
            .join('')}
        }`;

        const response = await fetch(this.storefrontApiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': this.storefrontAccessToken,
          },
          body: JSON.stringify({ query }),
        });

        if (!response.ok) {
          console.log('[BRAND] Storefront API request failed:', response.status);
          return products;
        }

        const data = await response.json();

        if (data.errors) {
          console.log('[BRAND] GraphQL errors:', data.errors);
          return products;
        }

        console.log('[BRAND] Storefront API response:', data);

        // Map brand IDs back to products by matching handles
        products.forEach((product) => {
          const handle = product.handle || (product.url ? product.url.match(/\/products\/([^?]+)/)?.[1] : null);
          if (handle && data.data) {
            // Find the matching product data from GraphQL response by handle
            for (let i = 0; i < handlesToQuery.length; i++) {
              const productData = data.data[`product${i}`];
              if (productData && productData.handle === handle) {
                if (productData.metafield && productData.metafield.value) {
                  product._brandId = productData.metafield.value;
                  console.log(`[BRAND] Found brand ID ${product._brandId} for product: ${product.title}`);
                }
                break;
              }
            }
          }
        });

        return products;
      } catch (error) {
        console.error('[BRAND] Error fetching brand IDs:', error);
        return products;
      }
    }

    async getSearchResults(searchTerm) {
      // Circuit breaker check
      if (this.isCircuitOpen) {
        const now = Date.now();
        if (now < this.circuitResetTime) {
          console.log('[ERROR] Circuit breaker is open, skipping request');
          this.displayError(this.translations.searchTemporarilyDisabled);
          return;
        } else {
          // Try to reset circuit
          console.log('[RETRY] Attempting to reset circuit breaker');
          this.isCircuitOpen = false;
          this.rateLimitCount = 0;
          this.backoffDelay = 1000;
        }
      }

      // Enhanced rate limiting check
      const now = Date.now();
      const timeSinceLastRequest = now - this.lastRequestTime;

      if (timeSinceLastRequest < this.minRequestInterval) {
        const waitTime = this.minRequestInterval - timeSinceLastRequest;
        console.log(`[RATE LIMIT] Rate limiting: waiting ${waitTime}ms before making request...`);
        await new Promise((resolve) => setTimeout(resolve, waitTime));
      }

      // Check for too many concurrent requests
      if (this.activeRequests >= this.maxConcurrentRequests) {
        console.log('[CONCURRENT] Too many concurrent requests, skipping...');
        return;
      }

      this.activeRequests++;
      this.lastRequestTime = Date.now();

      this.input.setAttribute('aria-expanded', 'true');
      this.classList.add('predictive-search--loading');
      this.results.style.display = 'none';

      // Check if this is a numeric-only search
      const isNumericSearch = /^\d+$/.test(searchTerm);

      if (isNumericSearch) {
        const searchingMessage = this.translations.searchingExact;

        this.results.innerHTML = `<div class="predictive-search__searching-message">${searchingMessage}</div>`;
        this.results.style.display = 'block';
      }

      try {
        // ── CPI lookup – fire in parallel with the Shopify request so we don't
        // pay two round-trip latencies.  Only query CPI when the term looks like
        // a code (contains a digit or hyphen); pure-text searches like "paint" or
        // "stretched canvas" are fully covered by Shopify and don't need CPI.
        const mightBeCode = /[0-9\-]/.test(searchTerm);
        const cpiPromise = mightBeCode
          ? this.checkMpnMatch(searchTerm)
          : Promise.resolve([]);

        let response;
        let data;
        let useLocale = this.currentLocale && this.currentLocale !== 'en';

        // Build search URL
        const searchParams = new URLSearchParams({
          q: searchTerm,
          'resources[type]': 'product,article,page,collection',
        });

        // For numeric searches, use enhanced query
        if (isNumericSearch) {
          // Check if this looks like a barcode format
          const cleanTerm = searchTerm.replace(/[-\s]/g, '');
          const isLikelyBarcode =
            /^\d{8}$/.test(cleanTerm) || // EAN-8
            /^\d{10}$/.test(cleanTerm) || // ISBN-10
            /^\d{12}$/.test(cleanTerm) || // UPC-A, GTIN-12
            /^\d{13}$/.test(cleanTerm) || // EAN-13, ISBN-13, GTIN-13
            /^\d{14}$/.test(cleanTerm) || // GTIN-14
            /^\d{6}$/.test(cleanTerm); // UPC-E

          // Use only SEARCHABLE fields (per Shopify predictive search API docs)
          // - variants.sku: SKU matches
          // - variants.barcode: Barcode matches
          // Family ID and MPN are now handled exclusively by the CPI (metafield-based),
          // so tag:family and tag:family_id are intentionally omitted here.
          // Note: Metafields are NOT searchable in the Shopify predictive search API.
          let expandedSearchQuery = `${searchTerm} OR variants.sku:${searchTerm}`;

          // Add barcode search if this looks like a barcode
          if (isLikelyBarcode) {
            expandedSearchQuery += ` OR variants.barcode:${searchTerm}`;
            console.log('[BARCODE] Added variants.barcode field to search for barcode match');
          }

          searchParams.set('q', expandedSearchQuery);
          console.log('[NUMERIC] Using enhanced numeric search with query:', expandedSearchQuery);
        }

        // Try with locale first (if not English)
        if (useLocale) {
          searchParams.set('locale', this.currentLocale);
          console.log('[LOCALE] Search request with locale:', this.currentLocale);
          console.log('[SEARCH] Search URL:', `/search/suggest.json?${searchParams.toString()}`);
        }

        let attemptCount = 0;
        const maxAttempts = 3;

        while (attemptCount < maxAttempts) {
          attemptCount++;

          try {
            response = await fetch(`/search/suggest.json?${searchParams.toString()}`);

            if (response.status === 429) {
              this.rateLimitCount++;
              console.log(
                `[WARNING] Rate limited (attempt ${attemptCount}/${maxAttempts}), count: ${this.rateLimitCount}`
              );

              if (this.rateLimitCount >= 3) {
                // Open circuit breaker
                console.log('[ERROR] Opening circuit breaker due to repeated rate limiting');
                this.isCircuitOpen = true;
                this.circuitResetTime = Date.now() + this.circuitTimeout;
                throw new Error('Circuit breaker opened');
              }

              if (attemptCount === 1 && useLocale) {
                // First attempt failed with locale, try without locale
                console.log('[RELOAD] Falling back to search without locale parameter');
                searchParams.delete('locale');
                useLocale = false;

                // Wait with exponential backoff
                await new Promise((resolve) => setTimeout(resolve, this.backoffDelay));
                this.backoffDelay = Math.min(this.backoffDelay * 2, this.maxBackoffDelay);
                continue;
              } else {
                // Wait with exponential backoff before retry
                const waitTime = this.backoffDelay * attemptCount;
                console.log(`[WAITING] Waiting ${waitTime}ms before retry...`);
                await new Promise((resolve) => setTimeout(resolve, waitTime));
                continue;
              }
            }

            if (!response.ok) {
              throw new Error(`Search API returned ${response.status}: ${response.statusText}`);
            }

            // Success! Reset rate limiting counters
            this.rateLimitCount = 0;
            this.backoffDelay = 1000;

            data = await response.json();
            console.log(
              '[SUCCESS] Search successful',
              useLocale ? `with locale ${this.currentLocale}` : 'without locale'
            );
            break;
          } catch (fetchError) {
            if (attemptCount === maxAttempts) {
              throw fetchError;
            }
          }
        }

        console.log('[SEARCH] Search API response:', data);

        // If we got no results for a barcode-like search, try a simpler approach
        if (isNumericSearch && (!data.resources.results.products || data.resources.results.products.length === 0)) {
          const cleanTerm = searchTerm.replace(/[-\s]/g, '');
          const isLikelyBarcode =
            /^\d{8}$/.test(cleanTerm) || // EAN-8
            /^\d{10}$/.test(cleanTerm) || // ISBN-10
            /^\d{12}$/.test(cleanTerm) || // UPC-A, GTIN-12
            /^\d{13}$/.test(cleanTerm) || // EAN-13, ISBN-13, GTIN-13
            /^\d{14}$/.test(cleanTerm) || // GTIN-14
            /^\d{6}$/.test(cleanTerm); // UPC-E

          if (isLikelyBarcode) {
            console.log('[RELOAD] No results found with enhanced query, trying simple barcode search...');

            try {
              // Try a simple search for just the barcode term
              const simpleParams = new URLSearchParams({
                q: searchTerm,
                'resources[type]': 'product',
              });

              if (useLocale) {
                simpleParams.set('locale', this.currentLocale);
              }

              const simpleResponse = await fetch(`/search/suggest.json?${simpleParams.toString()}`);
              if (simpleResponse.ok) {
                const simpleData = await simpleResponse.json();
                console.log('[SEARCH] Simple barcode search response:', simpleData);

                if (
                  simpleData.resources &&
                  simpleData.resources.results &&
                  simpleData.resources.results.products &&
                  simpleData.resources.results.products.length > 0
                ) {
                  console.log('[SUCCESS] Found results with simple search, merging with main data');
                  data.resources.results.products = simpleData.resources.results.products;
                } else {
                  console.log('[RELOAD] Simple search also failed, trying wildcard search...');

                  // Try a wildcard/broader search
                  const wildcardParams = new URLSearchParams({
                    q: `*${searchTerm}*`,
                    'resources[type]': 'product',
                  });

                  if (useLocale) {
                    wildcardParams.set('locale', this.currentLocale);
                  }

                  const wildcardResponse = await fetch(`/search/suggest.json?${wildcardParams.toString()}`);
                  if (wildcardResponse.ok) {
                    const wildcardData = await wildcardResponse.json();
                    console.log('[SEARCH] Wildcard search response:', wildcardData);

                    if (
                      wildcardData.resources &&
                      wildcardData.resources.results &&
                      wildcardData.resources.results.products &&
                      wildcardData.resources.results.products.length > 0
                    ) {
                      console.log('[SUCCESS] Found results with wildcard search, merging with main data');
                      data.resources.results.products = wildcardData.resources.results.products;
                    }
                  }
                }
              }
            } catch (error) {
              console.log('[WARNING] Simple barcode search failed:', error);
            }

            // As a last resort, try getting some recent products and manually filter by barcode
            console.log('[RELOAD] Trying to fetch recent products and manually filter by barcode...');
            try {
              const recentParams = new URLSearchParams({
                q: '',
                'resources[type]': 'product',
                'resources[limit]': '20',
              });

              if (useLocale) {
                recentParams.set('locale', this.currentLocale);
              }

              const recentResponse = await fetch(`/search/suggest.json?${recentParams.toString()}`);
              if (recentResponse.ok) {
                const recentData = await recentResponse.json();
                console.log('[SEARCH] Recent products for manual filtering:', recentData);

                if (recentData.resources && recentData.resources.results && recentData.resources.results.products) {
                  // This won't find the specific barcode product, but at least we can test if products come back
                  // The actual barcode matching will happen in the displayResults method
                  console.log(
                    '[BARCODE MATCH] Got recent products - barcode matching will happen during result processing'
                  );
                }
              }
            } catch (error) {
              console.log('[WARNING] Recent products fetch failed:', error);
            }
          }
        }

        // Basic debugging for translation
        if (
          data.resources &&
          data.resources.results &&
          data.resources.results.products &&
          data.resources.results.products.length > 0
        ) {
          console.log('[RESULTS] Search Results:');
          console.log('- Total products found:', data.resources.results.products.length);
          console.log('- Used locale parameter:', useLocale ? this.currentLocale : 'none');

          const firstProduct = data.resources.results.products[0];
          console.log(`[PRODUCT] First Product: "${firstProduct.title}"`);

          // Check for Spanish content
          if (this.currentLocale === 'es') {
            const hasSpanishWords =
              /\b(de|del|para|con|en|y|el|la|los|las|un|una|producto|color|tamaño|arte|pintura|dibujo|papel|lienzo|conjunto)\b/i.test(
                firstProduct.title
              );
            console.log(`[LOCALE] Contains Spanish words: ${hasSpanishWords}`);

            if (!hasSpanishWords && useLocale) {
              console.log('[INFO] Product may not have Spanish translation in Shopify Translate & Adapt');
              console.log('[RELOAD] Attempting to fetch translated product data...');

              // Try to get translated titles by fetching individual product data
              try {
                const translationPromises = data.resources.results.products.slice(0, 5).map(async (product) => {
                  if (product.handle) {
                    try {
                      // Try multiple endpoints for translated content
                      const endpoints = [
                        `/products/${product.handle}.js?locale=${this.currentLocale}`,
                        `/${this.currentLocale}/products/${product.handle}.js`,
                      ];

                      for (const endpoint of endpoints) {
                        try {
                          const response = await fetch(endpoint);
                          if (response.ok) {
                            const productData = await response.json();

                            if (productData.title && productData.title !== product.title) {
                              console.log(`[SUCCESS] Found translation for ${product.handle}:`);
                              console.log(`   - English: "${product.title}"`);
                              console.log(`   - Spanish: "${productData.title}"`);
                              product.title = productData.title;

                              // Also update variants if available and better translated
                              if (productData.variants && productData.variants.length > 0) {
                                product.variants = productData.variants;
                              }
                              break;
                            }
                          }
                        } catch (endpointError) {
                          // Continue to next endpoint
                          continue;
                        }
                      }
                    } catch (productError) {
                      console.log(`[WARNING] Could not fetch translations for ${product.handle}`);
                    }
                  }
                });

                // Wait for translations with a reasonable timeout
                await Promise.allSettled(translationPromises);
                console.log('[TRANSLATION] Translation fetch completed');

                // If we still don't have Spanish titles, try one more approach using liquid templates
                const stillNeedsTranslation = data.resources.results.products.some((product) => {
                  const hasSpanish =
                    /\b(de|del|para|con|en|y|el|la|los|las|un|una|producto|color|tamaño|arte|pintura|dibujo|papel|lienzo|conjunto)\b/i.test(
                      product.title
                    );
                  return !hasSpanish;
                });

                if (stillNeedsTranslation) {
                  console.log('[RELOAD] Trying liquid template approach for translations...');

                  try {
                    // Try using a search results template that might render with proper locale
                    const liquidSearchUrl = `/${this.currentLocale}/search?q=${encodeURIComponent(
                      searchTerm
                    )}&type=product&view=json`;
                    console.log('[LOCALE] Trying liquid search:', liquidSearchUrl);

                    const liquidResponse = await fetch(liquidSearchUrl);
                    if (liquidResponse.ok) {
                      try {
                        const liquidData = await liquidResponse.json();
                        if (liquidData.products && liquidData.products.length > 0) {
                          console.log('[SUCCESS] Found products via liquid template approach');

                          // Update titles with liquid-rendered translations
                          liquidData.products.forEach((liquidProduct, index) => {
                            if (index < data.resources.results.products.length) {
                              const searchProduct = data.resources.results.products[index];
                              if (liquidProduct.title && liquidProduct.title !== searchProduct.title) {
                                console.log(
                                  `[UPDATE] Updating from liquid: "${searchProduct.title}" -> "${liquidProduct.title}"`
                                );
                                searchProduct.title = liquidProduct.title;
                              }
                            }
                          });
                        }
                      } catch (jsonError) {
                        console.log('[DOM] Liquid response is not JSON, trying text parsing...');

                        // If it's HTML, try to extract product titles
                        const liquidText = await liquidResponse.text();
                        if (liquidText.includes('data-product-title')) {
                          console.log('[SEARCH] Found HTML with product data, attempting to parse...');
                          // Could add HTML parsing here if needed
                        }
                      }
                    }
                  } catch (liquidError) {
                    console.log('[WARNING] Liquid template approach failed:', liquidError);
                  }
                }
              } catch (translationError) {
                console.log('[WARNING] Translation fetch failed:', translationError);
              }
            }
          }
        }

        // Await CPI results (already started in parallel above).
        // Filter out pure Title/vendor matches – those are already returned by
        // Shopify suggest and should not appear in the "exact match" section.
        const rawCpiMatches = await cpiPromise;
        const mpnMatches = rawCpiMatches.filter((m) => m.matchType !== 'Title');

        // Process the results
        let products = data.resources.results.products || [];

        // Filter out products where all variants are discontinued
        if (products.length > 0) {
          console.log('[DISCONTINUED] Filtering discontinued products...');
          products = await this.filterDiscontinuedProducts(products, searchTerm);
        }

        // Fetch brand IDs for products via Storefront API.
        // NOTE: The Custom Index _brandId merge happens later inside displayResults, so at this
        // point no product has _brandId yet regardless of _customIndexHandles membership.
        // Always fetch via Storefront API for any product missing _brandId so that all result
        // cards (exact matches AND regular list items) have a logo available.
        const needsBrandLookup = products.filter((p) => !p._brandId);
        if (needsBrandLookup.length > 0) {
          console.log('[BRAND] Fetching brand IDs for products...');
          products = await this.fetchBrandIdsForProducts(products);
        } else if (products.length > 0) {
          console.log('[BRAND] All products already have brand IDs set');
        }

        const results = {
          products: products,
          articles: data.resources.results.articles || [],
          pages: data.resources.results.pages || [],
          collections: data.resources.results.collections || [],
          mpnMatches: mpnMatches, // Pass MPN match info to displayResults
        };

        console.log('[PROCESSING] Processing search results:', results);
        this.displayResults(results);
      } catch (error) {
        console.error('Error fetching search results:', error);

        if (error.message.includes('Circuit breaker')) {
          this.displayError(this.translations.searchDisabledServer);
        } else if (error.message.includes('429')) {
          this.displayError(this.translations.tooManyRequests);
        } else {
          this.displayError(this.translations.searchError);
        }
      } finally {
        // Always clean up
        this.activeRequests = Math.max(0, this.activeRequests - 1);
        this.classList.remove('predictive-search--loading');
      }
    }

    displayError(message) {
      this.results.innerHTML = `<div class="predictive-search__error">${message}</div>`;
      this.results.style.display = 'block';
    }

    displayResults(data) {
      console.log('Processing search results:', data);
      let resultsHtml = '';

      // Get the search term from the input
      const searchTerm = this.input.value.trim();

      // Check if search term is numeric - could be a SKU, Family ID, MPN, or Barcode
      const isNumericSearch = /^\d+$/.test(searchTerm);
      let exactMatches = [];

      // Extract MPN matches from data
      const mpnMatches = data.mpnMatches || [];

      // Check if we have MPN matches from sidecar
      const hasMpnMatches = mpnMatches.length > 0;

      // For numeric searches, add a note if we found no results (but not if we have MPN matches)
      if (isNumericSearch && (!data.products || data.products.length === 0) && !hasMpnMatches) {
        resultsHtml += `
        <div class="predictive-search__no-results">
          <p>No matches found for "${searchTerm}".</p>
        </div>
      `;
      } else if ((isNumericSearch && data.products && data.products.length > 0) || hasMpnMatches) {
        console.log('Numeric search with results detected:', searchTerm);
        console.log('First product object from API:', JSON.stringify(data.products[0], null, 2));

        // Always create exact match entries from CPI/sidecar results.
        // This runs even when Shopify also returned products (e.g. same value is both SKU and MPN).
        // The expansion dedup loop below prevents duplicate product+type entries.
        if (hasMpnMatches) {
          console.log('[CustomIndex] Creating product cards from index matches');
          mpnMatches.forEach((match) => {
            const handle = match.productHandle || match.handle || '';
            exactMatches.push({
              handle,
              url: `/products/${handle}`,
              title: match.productTitle,
              image: match.imageUrl,
              price: match.price,
              _exactMatchType: match.matchType || 'MPN',
              _matchedField: match.matchedField || null,
              _mpnValue: match.mpn,
              _familyId: match.familyId || null,
              _barcodeValue: match.barcode || null,
              _matchedVariantIndex: 0,
              _brandId: match.brandId || null,
              variantId: match.variantId || null,
              sku: match.sku,
              barcode: match.barcode || null,
              variantTitle: match.variantTitle,
              tags: match.tags || [],
              vendor: match.vendor || null,
              variants: [
                {
                  id: match.variantId || null,
                  sku: match.sku,
                  barcode: match.barcode || null,
                  price: match.price,
                  title: match.variantTitle,
                },
              ],
            });
          });
          console.log('[CustomIndex] Created', exactMatches.length, 'exact matches from index data');
        }

        // Search through products for exact matches
        const productMatches = (data.products || []).filter((product) => {
          // Extract handle from URL if not directly available
          if (!product.handle && product.url) {
            const handleMatch = product.url.match(/\/products\/([^?]+)/);
            if (handleMatch) {
              product.handle = handleMatch[1];
              console.log(`[SKU CHECK] Extracted handle from URL: ${product.handle}`);
            }
          }

          // Check for Custom Index match FIRST (covers MPN, SKU, Barcode, Family ID, etc.)
          if (mpnMatches.length > 0) {
            const mpnMatch = mpnMatches.find((match) => {
              const mh = match.productHandle || match.handle || '';
              return mh && (product.handle === mh || product.url?.includes('/' + mh));
            });

            if (mpnMatch) {
              product._exactMatchType = mpnMatch.matchType || 'MPN';
              product._matchedVariantIndex = 0;
              product._mpnValue = mpnMatch.mpn;
              product._barcodeValue = mpnMatch.barcode || null;
              product._brandId = mpnMatch.brandId || product._brandId || null;
              // Merge tags from index response so family ID renders correctly
              if (mpnMatch.tags && mpnMatch.tags.length > 0 && (!product.tags || !product.tags.length)) {
                product.tags = mpnMatch.tags;
              }
              console.log(
                `[SUCCESS] MATCH: ${product._exactMatchType} matches search term "${searchTerm}" via Custom Index`
              );
              return true;
            }
          }

          // Trust exact SKU match found from Storefront variant data.
          if (product._hasExactSkuMatch) {
            product._exactMatchType = 'SKU';
            console.log(
              `[SUCCESS] EXACT SKU MATCH from Storefront variants for product "${product.title}" and search "${searchTerm}"`
            );
            return true;
          }

          // Check for MPN, Family, and Barcode in product tags
          if (product.tags) {
            console.log(`Checking product tags for ${product.title}, Tags:`, product.tags);

            // Look for MPN tag with format "mpn:[xxxxxx]"
            const mpnTag = product.tags.find((tag) => tag.startsWith('mpn:'));
            if (mpnTag) {
              const mpnValue = mpnTag.split(':')[1];
              console.log(`Found MPN in product tags: "${mpnValue}" for product: ${product.title}`);

              if (mpnValue && mpnValue.toLowerCase() === searchTerm.toLowerCase()) {
                product._exactMatchType = 'MPN';
                product._matchedVariantIndex = 0;
                product._mpnValue = mpnValue;
                console.log(`[SUCCESS] MATCH: MPN "${mpnValue}" from tag matches search term "${searchTerm}"`);
                return true;
              }
            }

            // Family ID matching is handled exclusively by the CPI via the
            // custom.family_id metafield — no tag-based family detection here.

            // Look for barcode tag with format "barcode:[xxxxxx]" (legacy)
            const barcodeTag = product.tags.find((tag) => tag.startsWith('barcode:'));
            if (barcodeTag) {
              const barcodeValue = barcodeTag.split(':')[1];
              console.log(`Found Barcode in product tags: "${barcodeValue}" for product: ${product.title}`);

              // Clean both values for comparison (remove hyphens and spaces)
              const cleanBarcode = barcodeValue.replace(/[-\s]/g, '');
              const cleanSearchTerm = searchTerm.replace(/[-\s]/g, '');

              if (cleanBarcode.toLowerCase() === cleanSearchTerm.toLowerCase()) {
                product._exactMatchType = 'Barcode';
                product._matchedVariantIndex = 0;
                console.log(`[SUCCESS] MATCH: Barcode "${barcodeValue}" from tag matches search term "${searchTerm}"`);
                return true;
              }
            }
          }

          // Check variant barcodes from variants.barcode field (primary barcode source)
          if (product.variants && product.variants.length > 0) {
            for (let i = 0; i < product.variants.length; i++) {
              const variant = product.variants[i];
              if (variant.barcode) {
                const cleanBarcode = variant.barcode.replace(/[-\s]/g, '');
                const cleanSearchTerm = searchTerm.replace(/[-\s]/g, '');

                if (cleanBarcode.toLowerCase() === cleanSearchTerm.toLowerCase()) {
                  product._exactMatchType = 'Barcode';
                  product._matchedVariantIndex = i;
                  product._barcodeValue = variant.barcode;
                  console.log(
                    `[MATCH]: Barcode "${variant.barcode}" from variants.barcode field matches search term "${searchTerm}"`
                  );
                  return true;
                }
              }
            }
          }

          // First check if search term looks like a barcode format (for use in handle/URL checks)
          const cleanTerm = searchTerm.replace(/[-\s]/g, '');

          // SKU must be exactly 5 digits - no fuzzy matching
          const isExactSku = /^\d{5}$/.test(cleanTerm);

          const isLikelyBarcode =
            /^\d{8}$/.test(cleanTerm) || // EAN-8
            /^\d{10}$/.test(cleanTerm) || // ISBN-10
            /^\d{12}$/.test(cleanTerm) || // UPC-A, GTIN-12
            /^\d{13}$/.test(cleanTerm) || // EAN-13, ISBN-13, GTIN-13
            /^\d{14}$/.test(cleanTerm) || // GTIN-14
            /^\d{6}$/.test(cleanTerm); // UPC-E

          // Only check for SKU matches if search term is exactly 5 digits
          if (isExactSku) {
            console.log(
              `[SKU CHECK] Checking for exact 5-digit SKU match: "${searchTerm}" for product: ${product.title}`
            );
            console.log(`[SKU CHECK] Product handle: ${product.handle}`);
            console.log(`[SKU CHECK] Product URL: ${product.url}`);

            // Check all variants for exact SKU match (if available from API)
            if (product.variants && product.variants.length > 0) {
              for (let i = 0; i < product.variants.length; i++) {
                const variant = product.variants[i];
                const directSku = variant?.sku || '';
                const nestedSku = variant?.sku?.value || '';
                const possibleSkus = [directSku, nestedSku].filter((s) => s);

                if (possibleSkus.length > 0) {
                  console.log(`[SKU CHECK] Variant ${i} SKUs:`, possibleSkus);
                }

                // Check for EXACT SKU match only
                const matchingSku = possibleSkus.find((sku) => sku.trim() === searchTerm);

                if (matchingSku) {
                  product._exactMatchType = 'SKU';
                  product._matchedVariantIndex = i;
                  console.log(
                    `[SUCCESS] EXACT SKU MATCH from variant: "${matchingSku}" matches search term "${searchTerm}"`
                  );
                  return true;
                }
              }
            }

            // Check if product handle contains the exact SKU (with hyphen prefix)
            // Handles are typically formatted as "product-name-12345"
            if (product.handle && product.handle.includes('-' + searchTerm)) {
              product._exactMatchType = 'SKU';
              product._matchedVariantIndex = 0;
              console.log(`[SUCCESS] EXACT SKU MATCH in handle: ${product.handle} contains -${searchTerm}`);
              return true;
            }

            // Also check if handle ends with the SKU directly
            if (product.handle && product.handle.endsWith(searchTerm)) {
              product._exactMatchType = 'SKU';
              product._matchedVariantIndex = 0;
              console.log(`[SUCCESS] EXACT SKU MATCH: handle ${product.handle} ends with ${searchTerm}`);
              return true;
            }

            // Check if product URL contains the SKU pattern
            if (product.url && product.url.includes('-' + searchTerm)) {
              product._exactMatchType = 'SKU';
              product._matchedVariantIndex = 0;
              console.log(`[SUCCESS] EXACT SKU MATCH in URL: ${product.url} contains -${searchTerm}`);
              return true;
            }

            // If Shopify returned this product for a 5-digit search, trust their matching
            // The predictive search API doesn't return variant.sku, but Shopify's backend knows
            // If only 1 product is returned for a 5-digit search, it's very likely an SKU match
            if (data.products.length === 1) {
              product._exactMatchType = 'SKU';
              product._matchedVariantIndex = 0;
              console.log(
                `[SUCCESS] EXACT SKU MATCH: Single result for 5-digit search "${searchTerm}" - trusting Shopify match`
              );
              return true;
            }
          }

          // Check for barcode matches (must be exact barcode format)
          if (isLikelyBarcode) {
            // Predictive Search API doesn't return variant.barcode
            // But if Shopify returned this product for a barcode search, trust it
            // Especially if it's the only result
            if (data.products.length === 1) {
              product._exactMatchType = 'Barcode';
              product._matchedVariantIndex = 0;
              product._barcodeValue = searchTerm;
              console.log(
                `[SUCCESS] BARCODE MATCH: Single result for barcode search "${searchTerm}" - trusting Shopify match`
              );
              return true;
            }

            // For multiple results, check if variants have barcode data (rare but possible)
            if (product.variants && product.variants.length > 0) {
              for (let i = 0; i < product.variants.length; i++) {
                const variant = product.variants[i];
                const barcode = variant?.barcode || '';

                if (barcode && barcode.trim() === searchTerm) {
                  product._exactMatchType = 'Barcode';
                  product._matchedVariantIndex = i;
                  product._barcodeValue = searchTerm;
                  console.log(`[SUCCESS] EXACT BARCODE MATCH: "${barcode}" matches search term "${searchTerm}"`);
                  return true;
                }
              }
            }
          }

          return false;
        });

        // Combine MPN-created matches with product filter matches
        exactMatches = exactMatches.concat(productMatches);

        // Expand exact matches so one product can show multiple exact match types
        // (e.g. exact SKU + exact Family ID for the same query).
        const exactMatchEntries = [];
        const exactMatchEntryKeys = new Set();
        const normalizedSearchTerm = searchTerm.trim().toLowerCase();

        exactMatches.forEach((product) => {
          const matchTypes = new Set();
          const fallbackType = product._exactMatchType;
          const variants = Array.isArray(product.variants) ? product.variants : [];
          const productHandle = product.handle || '';
          const productUrl = product.url || '';
          let matchedSkuVariantIndex = -1;

          if (fallbackType) {
            matchTypes.add(fallbackType);
          }

          // Family ID matching is owned by the CPI (custom.family_id metafield).
          // Tag-based secondary family detection has been intentionally removed.

          // Secondary exact SKU match detection so it can be shown alongside Family/MPN.
          if (/^\d{5}$/.test(searchTerm.trim())) {
            if (product._hasExactSkuMatch || product._storefrontExactSku === searchTerm) {
              matchTypes.add('SKU');
            }

            variants.forEach((variant, index) => {
              const directSku = variant?.sku || '';
              const nestedSku = variant?.sku?.value || '';
              const possibleSkus = [directSku, nestedSku].filter((sku) => sku);
              const hasExactSku = possibleSkus.some((sku) => sku.trim() === searchTerm);

              if (hasExactSku && matchedSkuVariantIndex === -1) {
                matchedSkuVariantIndex = index;
              }
            });

            if (
              matchedSkuVariantIndex !== -1 ||
              (productHandle && (productHandle.includes('-' + searchTerm) || productHandle.endsWith(searchTerm))) ||
              (productUrl && productUrl.includes('-' + searchTerm))
            ) {
              matchTypes.add('SKU');
            }
          }

          // Secondary MPN match detection so it shows alongside SKU/Family matches.
          // Checks both productHandle (CPI format) and handle (legacy sidecar format).
          if (mpnMatches.length > 0) {
            const mpnMatchForProduct = mpnMatches.find((match) => {
              const mh = match.productHandle || match.handle || '';
              return mh && (productHandle === mh || productUrl.includes('/' + mh));
            });
            if (mpnMatchForProduct) {
              matchTypes.add(mpnMatchForProduct.matchType || 'MPN');
              // Even if CPI marks this as SKU, also show MPN when the returned MPN exactly matches query.
              const matchMpn = (mpnMatchForProduct.mpn || '').toString().trim().toLowerCase();
              if (matchMpn && matchMpn === normalizedSearchTerm) {
                matchTypes.add('MPN');
              }
              if (mpnMatchForProduct.mpn && !product._mpnValue) {
                product._mpnValue = mpnMatchForProduct.mpn;
              }
            }
          }

          if (matchTypes.size === 0 && fallbackType) {
            matchTypes.add(fallbackType);
          }

          matchTypes.forEach((type) => {
            const stableIdentity =
              product.handle ||
              (product.url && product.url.match(/\/products\/([^?]+)/)?.[1]) ||
              product.id ||
              product.title;
            const entryKey = `${stableIdentity}-${type}`;
            if (exactMatchEntryKeys.has(entryKey)) return;
            exactMatchEntryKeys.add(entryKey);

            const exactMatchEntry = {
              ...product,
              _exactMatchType: type,
            };

            if (type === 'SKU' && matchedSkuVariantIndex !== -1) {
              exactMatchEntry._matchedVariantIndex = matchedSkuVariantIndex;
            }

            exactMatchEntries.push(exactMatchEntry);
          });
        });

        // If the query matched a specific SKU, don't also surface Family entries.
        // The family product showing beneath an exact SKU result confuses customers.
        const hasSkuExactMatch = exactMatchEntries.some((e) => e._exactMatchType === 'SKU');
        exactMatches = hasSkuExactMatch
          ? exactMatchEntries.filter((e) => e._exactMatchType !== 'Family')
          : exactMatchEntries;

        console.log('Exact matches found:', exactMatches.length);

        // If we found exact matches, show them first with a special flag
        if (exactMatches.length > 0) {
          resultsHtml += `
          <div class="predictive-search__exact-matches">
            <ul class="predictive-search__list">
              ${exactMatches.map((product) => this.renderProductListItem(product, true)).join('')}
            </ul>
          </div>
        `;

          // Remove exact matches from the main products array to avoid duplication.
          // Use product handle (not .id) because CPI-created entries have no Shopify id.
          if (data.products && data.products.length > 0) {
            const exactMatchHandles = new Set(
              exactMatches
                .map((p) => p.handle || (p.url && p.url.match(/\/products\/([^?]+)/)?.[1]))
                .filter(Boolean)
            );
            data.products = data.products.filter((p) => {
              const h = p.handle || (p.url && p.url.match(/\/products\/([^?]+)/)?.[1]);
              return !h || !exactMatchHandles.has(h);
            });
          }
        }
      }

      // Check if search query matches any vendor names.
      // Look through both remaining data.products AND exactMatches so the vendor strip still appears
      // when all matching products were promoted to the exact matches section.
      const allProductsForVendorCheck = [...(data.products || []), ...exactMatches];
      if (allProductsForVendorCheck.length > 0) {
        const vendors = new Set(allProductsForVendorCheck.map((product) => product.vendor));
        const searchTermLower = searchTerm.toLowerCase();
        const matchingVendor = Array.from(vendors).find(
          (vendor) =>
            vendor && (vendor.toLowerCase().includes(searchTermLower) || searchTermLower.includes(vendor.toLowerCase()))
        );

        if (matchingVendor) {
          const encodedVendor = encodeURIComponent(matchingVendor);

          // Find brand ID from any product with this vendor (check exact matches + remaining products)
          const allAvailableProducts = [...exactMatches, ...(data.products || [])];
          const vendorProduct = allAvailableProducts.find(
            (p) => p.vendor && p.vendor.toLowerCase() === matchingVendor.toLowerCase() && p._brandId
          );
          const vendorBrandId = vendorProduct ? vendorProduct._brandId : null;

          const vendorStripLogoHtml = vendorBrandId
            ? `<span class="predictive-search__vendor-strip-logo">
                <img
                  src="https://texasart.b-cdn.net/brandpix/${vendorBrandId}.gif"
                  alt="${matchingVendor}"
                  onerror="this.parentElement.style.display='none';"
                >
              </span>`
            : '';

          resultsHtml += `
          <div class="predictive-search__vendor-strip">
            <a href="${window.routes.collections_url}/vendors?q=${encodedVendor}" class="predictive-search__vendor-link">
              ${vendorStripLogoHtml}
              ${this.translations.shopBrand} ${matchingVendor}
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M6 12L10 8L6 4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
        `;
        }
      }

      if (data.products && data.products.length > 0) {
        // Add debug info for first product
        const debugProduct = data.products[0];
        const debugVariant =
          debugProduct.variants && debugProduct.variants.length > 0 ? debugProduct.variants[0] : null;
        const debugSku = debugVariant && debugVariant.sku ? debugVariant.sku.trim() : '';

        console.log('First product debug info:');
        console.log('- Product title:', debugProduct.title);
        console.log('- SKU:', debugSku);
        console.log('- Variant:', debugVariant);

        if (debugSku) {
          const folderNumber = debugSku.charAt(0);
          const debugImageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${debugSku}.jpg?width=100`;
          console.log('- Generated Bunny CDN URL:', debugImageUrl);
        }

        resultsHtml += this.getProductsHtml(data.products);
      }

      if (data.collections && data.collections.length > 0) {
        resultsHtml += this.getCollectionsHtml(data.collections);
      }

      if (data.articles && data.articles.length > 0) {
        resultsHtml += this.getArticlesHtml(data.articles);
      }

      if (data.pages && data.pages.length > 0) {
        resultsHtml += this.getPagesHtml(data.pages);
      }

      if (!resultsHtml) {
        resultsHtml = '<div class="predictive-search__no-results">No results found</div>';
      }

      this.results.innerHTML = resultsHtml;
      this.results.style.display = 'block';

      // Add CSS for the exact match badge
      if (!document.getElementById('exact-match-badge-style')) {
        const style = document.createElement('style');
        style.id = 'exact-match-badge-style';
        style.textContent = `
        .predictive-search__exact-match-badge {
          position: absolute;
          top: 0;
          left: 0;
          background-color: #00a05d;
          color: white;
          font-size: 11px;
          padding: 6px 25px;
          text-transform: uppercase;
          font-weight: bold;
          letter-spacing: 0.5px;
          transform: rotate(-45deg) translateX(-22px) translateY(-10px);
          transform-origin: top left;
          z-index: 10;
          width: 140px;
          text-align: center;
          box-shadow: 0 1px 3px rgba(0,0,0,0.2);
        }
        
        @media screen and (max-width: 767px) {
          .predictive-search__exact-match-badge {
            font-size: 10px;
            padding: 4px 20px;
            width: 120px;
            transform: rotate(-45deg) translateX(-18px) translateY(-12px);
          }
        }
        
        .predictive-search__item.has-match-badge {
          position: relative;
          overflow: hidden;
        }
        
        .predictive-search__exact-matches {
          border-bottom: 1px solid #e5e5e5;
          padding: 10px;
          margin-bottom: 15px;
        }
        
        .predictive-search__item-sku,
        .predictive-search__item-family,
        .predictive-search__item-mpn,
        .predictive-search__item-barcode {
          font-size: 12px;
          color: #666;
          line-height: 1.4;
          margin-bottom: 4px;
        }
        .predictive-search__item-sku strong,
        .predictive-search__item-family strong,
        .predictive-search__item-mpn strong,
        .predictive-search__item-barcode strong {
          font-weight: 600;
          color: #333;
        }
        .predictive-search__variant-detail {
          font-size: 11px;
          color: #555;
          line-height: 1.4;
          margin-bottom: 2px;
        }
        .predictive-search__searching-message {
          padding: 20px;
          text-align: center;
          color: #666;
          font-style: italic;
          background-color: #f8f8f8;
          border-radius: 4px;
        }
        .predictive-search__suggestion {
          font-size: 13px;
          margin-top: 8px;
          color: #888;
          font-style: italic;
        }
        .predictive-search__no-results p {
          margin: 5px 0;
        }
      `;
        document.head.appendChild(style);
      }
    }

    // Helper method to render a product item in the search results
    renderProductListItem(product, isExactMatch) {
      // Get the variant - use the matched variant index for exact matches, or first variant as fallback
      let variant;
      if (isExactMatch && product._matchedVariantIndex !== undefined) {
        // Use the specific variant that matched
        variant = product.variants[product._matchedVariantIndex];
        console.log(
          `Using matched variant index ${product._matchedVariantIndex} for exact match product: ${product.title}`
        );
      } else {
        // Default to first variant
        variant = product.variants && product.variants.length > 0 ? product.variants[0] : null;
      }

      // Initialize SKU from various sources
      let sku = '';

      // Check variant.sku directly
      if (variant && variant.sku) {
        if (typeof variant.sku === 'string') {
          sku = variant.sku.trim();
        } else if (variant.sku.value) {
          // Handle case where sku is an object with a value property
          sku = variant.sku.value.trim();
        }
      }

      // If this is an exact match, use the search term as SKU when no explicit SKU is found
      if (isExactMatch && product._exactMatchType === 'SKU' && !sku) {
        // Use the search term as the SKU for exact matches
        const searchTerm = document
          .querySelector('.tas-search-form__input, .tas-mobile-search-form__input')
          .value.trim();
        if (/^\d+$/.test(searchTerm)) {
          sku = searchTerm;
          console.log(`Using search term as SKU for exact match: ${sku}`);
        }
      }

      // Extract SKU from URL if it contains 'prang-roll-on-green-liquid-glue'
      if (!sku && product.url && product.url.includes('prang-roll-on-green-liquid-glue')) {
        sku = '46978'; // Direct SKU for the Prang Roll-On Green Liquid Glue product
        console.log(`Found exact Prang glue product from URL - setting SKU to: ${sku}`);
      }
      // Look for specific product title patterns
      else if (
        !sku &&
        product.title &&
        product.title.toLowerCase().includes('roll-on green liquid glue') &&
        product.vendor &&
        product.vendor.toLowerCase() === 'prang'
      ) {
        sku = '46978'; // Direct SKU for the Prang Roll-On Green Liquid Glue product
        console.log(`Found Prang Roll-On Green Liquid Glue from title - setting SKU to: ${sku}`);
      }
      // Look for SKU in the product handle
      else if (!sku && product.handle) {
        // Try to extract SKU from the product handle
        const skuFromHandle = product.handle.match(/\d+$/);
        if (skuFromHandle) {
          sku = skuFromHandle[0];
          console.log(`Extracted SKU from handle: ${sku} for product: ${product.title}`);
        } else if (isExactMatch) {
          // For exact matches, check if the handle contains the search term number
          const searchTerm = document
            .querySelector('.tas-search-form__input, .tas-mobile-search-form__input')
            .value.trim();
          if (product.handle.includes(searchTerm) && /^\d+$/.test(searchTerm)) {
            sku = searchTerm;
            console.log(`Using search term as SKU from handle match: ${sku}`);
          }
        }
      }
      // Check if this is a numeric search and we have a variant ID
      else if (!sku && isExactMatch && variant && variant.id) {
        const searchTerm = document
          .querySelector('.tas-search-form__input, .tas-mobile-search-form__input')
          .value.trim();
        if (/^\d+$/.test(searchTerm)) {
          sku = searchTerm; // Use the search term as SKU if it's a numeric search
          console.log(`No explicit SKU found, using search term as SKU: ${sku}`);
        }
      }

      // Extract product vendor code for specific vendors like Prang
      let vendorCode = '';
      if (product.vendor && product.vendor.toLowerCase() === 'prang') {
        vendorCode = 'prang';
        console.log(`Found Prang product: ${product.title}`);
      }

      // Set up image URL variables
      let imageUrl = '';
      let familyId = '';
      let mpn = '';

      // Try to get family_id and mpn from tags.
      // CPI/sidecar payloads may provide tags as a string/object; normalize to a string array first.
      let productTags = [];
      if (Array.isArray(product.tags)) {
        productTags = product.tags.filter((tag) => typeof tag === 'string');
      } else if (typeof product.tags === 'string') {
        productTags = [product.tags];
      } else if (product.tags && typeof product.tags === 'object') {
        productTags = Object.values(product.tags).filter((tag) => typeof tag === 'string');
      }

      if (productTags.length > 0) {
        // MPN from tags (legacy fallback — CPI now surfaces this via _mpnValue)
        const mpnTag = productTags.find((tag) => tag.startsWith('mpn:'));
        if (mpnTag) {
          mpn = mpnTag.split(':')[1];
        }
      }

      // Family ID: prefer the CPI metafield value (_familyId), fall back to legacy tags
      // for products not yet migrated to the custom.family_id metafield.
      if (!familyId && product._familyId) {
        familyId = product._familyId;
      } else if (!familyId && productTags.length > 0) {
        const familyIdTag = productTags.find((tag) => tag.startsWith('family_id:') || tag.startsWith('family:'));
        if (familyIdTag) {
          familyId = familyIdTag.split(':')[1];
        }
      }

      // MPN: prefer CPI value over tag
      if (!mpn && product._mpnValue) {
        mpn = product._mpnValue;
      }

      // Get brand ID from Storefront API (fetched earlier)
      const brandId = product._brandId || '';

      // For exact SKU matches, prioritize SKU image from Bunny CDN
      if (isExactMatch && product._exactMatchType === 'SKU') {
        // Use SKU if available, otherwise use search term (which is what matched)
        const skuForImage = sku || this.input.value.trim();
        const folderNumber = skuForImage.charAt(0);
        imageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${skuForImage}.jpg?width=100`;
        console.log(
          `[IMAGE] EXACT SKU MATCH - using SKU image URL: ${imageUrl} for SKU ${skuForImage} for product: ${product.title}`
        );
      }
      // Otherwise, follow normal priority order
      else {
        // 1. Try family/group image first (if not an exact SKU match)
        if (familyId) {
          const familyIdNumber = parseInt(familyId);
          let familyFolder = '/000';

          if (familyIdNumber >= 1000) {
            const familyFolderNumber = Math.floor(familyIdNumber / 1000) * 1000;
            familyFolder = `/${familyFolderNumber}`;
          }

          imageUrl = `https://texasart.b-cdn.net/grouppix/2000x2000${familyFolder}/g${familyId}.jpg?width=100`;
          console.log(`Using family image URL: ${imageUrl} for product: ${product.title}`);
        }
        // 2. Try SKU variant image if family image is not available
        else if (sku) {
          const folderNumber = sku.charAt(0);
          imageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${sku}.jpg?width=100`;
          console.log(`Using SKU image URL: ${imageUrl} for product: ${product.title}`);
        }
        // 3. Handle specific vendors with known image patterns
        else if (vendorCode === 'prang' && product.title.toLowerCase().includes('roll-on green liquid glue')) {
          // Hard-code the image URL for this specific product shown in screenshot
          imageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/4/s46978.jpg?width=100`;
          console.log(`Using vendor-specific image URL: ${imageUrl} for product: ${product.title}`);
        }
        // 4. Fallback to Shopify product image if available (normalize texasart.com → CDN)
        else if (product.featured_image && product.featured_image.url) {
          imageUrl = product.featured_image.url;
          if (imageUrl && (imageUrl.includes('/grouppix/') || imageUrl.includes('/skupix/'))) {
            imageUrl = imageUrl.replace(/^https?:\/\/texasart\.com\//, 'https://texasart.b-cdn.net/');
          }
          console.log(`Falling back to featured_image URL: ${imageUrl} for product: ${product.title}`);
        } else if (product.image && product.image.url) {
          imageUrl = product.image.url;
          if (imageUrl && (imageUrl.includes('/grouppix/') || imageUrl.includes('/skupix/'))) {
            imageUrl = imageUrl.replace(/^https?:\/\/texasart\.com\//, 'https://texasart.b-cdn.net/');
          }
        } else if (typeof product.image === 'string') {
          imageUrl = product.image;
          if (imageUrl && (imageUrl.includes('/grouppix/') || imageUrl.includes('/skupix/'))) {
            imageUrl = imageUrl.replace(/^https?:\/\/texasart\.com\//, 'https://texasart.b-cdn.net/');
          }
        } else if (typeof product.featured_image === 'string') {
          imageUrl = product.featured_image;
          if (imageUrl && (imageUrl.includes('/grouppix/') || imageUrl.includes('/skupix/'))) {
            imageUrl = imageUrl.replace(/^https?:\/\/texasart\.com\//, 'https://texasart.b-cdn.net/');
          }
        } else {
          imageUrl = window.theme.assets.image_not_found;
        }
      }

      let productUrl = product.url;
      const vendorName = product.vendor || '';

      if (!productUrl) {
        console.error('Missing product URL:', product);
        return '';
      }

      // Set up a fallback mechanism using onerror for the image
      let imageTag = '';

      // For exact SKU matches, use a more direct approach with the SKU image
      if (isExactMatch && product._exactMatchType === 'SKU') {
        // Use SKU if available, otherwise use search term (which is what matched)
        const skuForImage = sku || this.input.value.trim();
        const folderNumber = skuForImage.charAt(0);
        const skuImageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${skuForImage}.jpg?width=100`;

        imageTag = `<img 
        src="${skuImageUrl}" 
        alt="${product.title}" 
        class="predictive-search__image" 
        onerror="console.log('SKU image failed to load: ' + this.src); this.onerror=null; this.src='${window.theme.assets.image_not_found}';"
      >`;
        console.log(`[IMAGE] Building exact SKU match image tag with URL: ${skuImageUrl} for SKU ${skuForImage}`);
      }
      // For numeric searches (even if not explicitly marked as exact match), try to use SKU image
      else if (/^\d+$/.test(this.input.value.trim()) && sku) {
        const folderNumber = sku.charAt(0);
        const skuImageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${sku}.jpg?width=100`;

        imageTag = `<img 
        src="${skuImageUrl}" 
        alt="${product.title}" 
        class="predictive-search__image" 
        onerror="console.log('Numeric search SKU image failed to load: ' + this.src); this.onerror=null; this.src='${window.theme.assets.image_not_found}';"
      >`;
        console.log(`[IMAGE] Building numeric search SKU image tag with URL: ${skuImageUrl}`);
      }
      // If search term is numeric but no SKU is found, try using the search term itself as SKU
      else if (/^\d+$/.test(this.input.value.trim()) && !sku) {
        const searchTerm = this.input.value.trim();
        const folderNumber = searchTerm.charAt(0);
        const skuImageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${searchTerm}.jpg?width=100`;

        imageTag = `<img 
        src="${skuImageUrl}" 
        alt="${product.title}" 
        class="predictive-search__image" 
        onerror="console.log('Search term as SKU image failed to load: ' + this.src); this.onerror=null; this.src='${window.theme.assets.image_not_found}';"
      >`;
        console.log(`[IMAGE] Using search term ${searchTerm} as SKU for image: ${skuImageUrl}`);
      }

      // For Family ID matches, use the family image first
      else if (isExactMatch && product._exactMatchType === 'Family' && familyId) {
        const familyIdNumber = parseInt(familyId);
        let familyFolder = '/000';

        if (familyIdNumber >= 1000) {
          const familyFolderNumber = Math.floor(familyIdNumber / 1000) * 1000;
          familyFolder = `/${familyFolderNumber}`;
        }

        const familyImageUrl = `https://texasart.b-cdn.net/grouppix/2000x2000${familyFolder}/g${familyId}.jpg?width=100`;

        if (sku) {
          // We have both family and SKU - try family first, then SKU, then default
          const folderNumber = sku.charAt(0);
          const skuImageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${sku}.jpg?width=100`;

          imageTag = `<img 
          src="${familyImageUrl}" 
          alt="${product.title}" 
          class="predictive-search__image" 
          onerror="console.log('Family image failed to load: ' + this.src); this.onerror=null; this.src='${skuImageUrl}'; this.onerror=function(){console.log('SKU image failed to load: ' + this.src); this.onerror=null; this.src='${window.theme.assets.image_not_found}';};"
        >`;
        } else {
          // We have family but no SKU - try family then default
          imageTag = `<img 
          src="${familyImageUrl}" 
          alt="${product.title}" 
          class="predictive-search__image" 
          onerror="console.log('Family image failed to load: ' + this.src); this.onerror=null; this.src='${window.theme.assets.image_not_found}';"
        >`;
        }
      }
      // If we have only SKU but no family
      else if (sku) {
        const folderNumber = sku.charAt(0);
        const skuImageUrl = `https://texasart.b-cdn.net/skupix/2000x2000/${folderNumber}/s${sku}.jpg?width=100`;

        imageTag = `<img 
        src="${skuImageUrl}" 
        alt="${product.title}" 
        class="predictive-search__image" 
        onerror="console.log('SKU image failed to load: ' + this.src); this.onerror=null; this.src='${window.theme.assets.image_not_found}';"
      >`;
      }
      // If we have neither, use the image URL calculated above
      else {
        imageTag = `<img 
        src="${imageUrl}" 
        alt="${product.title}" 
        class="predictive-search__image${!product.image && !product.featured_image ? ' fallback-image' : ''}" 
        onerror="console.log('Image failed to load: ' + this.src); this.onerror=null; this.src='${
          window.theme.assets.image_not_found
        }';"
      >`;
      }

      // Add exact match badge if this is an exact match.
      // Normalise verbose display_name values so the badge fits.
      let badgeText = product._exactMatchType ? product._exactMatchType.toUpperCase() : '';
      if (badgeText === 'BARCODE') badgeText = 'CODE';
      if (
        badgeText.includes('MANUFACTURER') ||
        badgeText.includes('MANUFACTURER_ITEM') ||
        (product._matchedField === 'custom.manufacturer_item_number' && badgeText !== 'MPN')
      ) {
        badgeText = 'MPN';
      }
      const exactMatchBadge = isExactMatch
        ? `<span class="predictive-search__exact-match-badge">${badgeText}<br>MATCH</span>`
        : '';

      // Display SKU/Barcode/MPN/Family ID based on match type
      // For exact matches, show the matched field prominently instead of Family ID
      let itemDetails = '';

      // Detect MPN matches regardless of how display_name is stored in metafield_configs
      // (e.g. "MPN", "Manufacturer Item Number", "manufacturer_item_number", etc.)
      const isMpnMatch =
        isExactMatch &&
        (product._exactMatchType === 'MPN' ||
          product._matchedField === 'custom.manufacturer_item_number' ||
          (product._exactMatchType || '').toLowerCase().includes('mpn') ||
          (product._exactMatchType || '').toLowerCase().includes('manufacturer'));

      // For exact SKU or MPN matches, send the user directly to the SKU detail page.
      if (isExactMatch && (product._exactMatchType === 'SKU' || isMpnMatch)) {
        const rawVariantId = (variant && variant.id) || product.variantId;
        // Handle both numeric IDs and GID strings (gid://shopify/ProductVariant/12345)
        const variantId = rawVariantId ? String(rawVariantId).split('/').pop() : null;
        if (variantId) {
          const handle = product.handle || (product.url && product.url.match(/\/products\/([^?]+)/)?.[1]);
          if (handle) {
            productUrl = `/products/${handle}?variant=${variantId}&view=sku-detail`;
            console.log(`[SKU DETAIL] Linking exact ${product._exactMatchType} match to SKU detail page: ${productUrl}`);
          }
        }
      }

      if (isExactMatch && product._exactMatchType === 'SKU') {
        // SKU Match – variant details already show the SKU
      } else if (isExactMatch && product._exactMatchType === 'Barcode') {
        const barcodeValue = product._barcodeValue || this.input.value.trim();
        itemDetails += `<div class="predictive-search__item-family"><strong>Barcode:</strong> ${barcodeValue}</div>`;
      } else if (isMpnMatch) {
        // MPN Match – show the MPN value; fall back to search term if not on product object
        const displayMpn = mpn || product._mpnValue || this.input.value.trim();
        itemDetails += `<div class="predictive-search__item-family"><strong>MPN:</strong> ${displayMpn}</div>`;
      } else if (familyId) {
        // Family ID Match or non-exact match - show Family ID
        itemDetails += `<div class="predictive-search__item-family"><strong>Family ID:</strong> ${familyId}</div>`;
        console.log(`[DISPLAY] Showing Family ID: ${familyId} for product: ${product.title}`);
      }

      // Generate vendor logo HTML if brand ID is available
      const vendorLogoHtml = brandId
        ? `<div class="predictive-search__vendor-logo">
            <img 
              src="https://texasart.b-cdn.net/brandpix/${brandId}.gif" 
              alt="${vendorName}" 
              onerror="this.parentElement.style.display='none';"
            >
          </div>`
        : '';

      // Add variant-level details (SKU and MPN) for exact matches
      let variantDetails = '';
      if (isExactMatch && (product._exactMatchType === 'SKU' || product._exactMatchType === 'Barcode')) {
        // For SKU matches, ensure we show the SKU (use search term if not available from API)
        const displaySkuVariant = sku || (product._exactMatchType === 'SKU' ? this.input.value.trim() : '');
        if (displaySkuVariant) {
          variantDetails += `<div class="predictive-search__variant-detail">SKU: ${displaySkuVariant}</div>`;
        }
        if (mpn) {
          variantDetails += `<div class="predictive-search__variant-detail">MPN: ${mpn}</div>`;
        }
      }

      return `
      <li class="predictive-search__item${isExactMatch ? ' has-match-badge' : ''}">
        <a href="${productUrl}" class="predictive-search__link">
          ${imageTag}
          ${exactMatchBadge}
          <div class="predictive-search__item-content">
            <div class="predictive-search__item-title">
              ${product.title}${
        vendorName ? ` - <span class="predictive-search__item-vendor">${vendorName}</span>` : ''
      }
            </div>
            ${variantDetails}
            ${itemDetails}
            <div class="predictive-search__item-price">${this.formatProductPrice(product, variant, isExactMatch)}</div>
          </div>
          ${vendorLogoHtml}
        </a>
      </li>
    `;
    }

    // Helper method to format product price based on context
    formatProductPrice(product, variant, isExactMatch) {
      // Helper to convert price to cents (predictive search API returns prices in dollars as strings)
      const toCents = (price) => {
        if (!price) return 0;
        const numPrice = typeof price === 'string' ? parseFloat(price) : price;
        // If price looks like it's already in cents (large number), return as is
        // Otherwise multiply by 100 to convert dollars to cents
        return numPrice > 1000 ? numPrice : Math.round(numPrice * 100);
      };

      // For exact matches (SKU/variant matches), show the specific variant's price
      if (isExactMatch && variant && variant.price) {
        const variantPriceCents = toCents(variant.price);
        const compareAtPriceCents = variant.compare_at_price ? toCents(variant.compare_at_price) : 0;

        // Show compare_at_price if it exists and is higher than current price
        if (compareAtPriceCents && compareAtPriceCents > variantPriceCents) {
          return `<span class="predictive-search__compare-price">${Shopify.formatMoney(
            compareAtPriceCents
          )}</span> ${Shopify.formatMoney(variantPriceCents)}`;
        }

        return Shopify.formatMoney(variantPriceCents);
      }

      // For family/product results, check if we should show a price range
      const priceMin = toCents(product.price_min || product.price);
      const priceMax = toCents(product.price_max);

      if (!priceMin) {
        return '';
      }

      // If there's a price range (min != max), show the range
      if (priceMax && priceMin !== priceMax) {
        return `${Shopify.formatMoney(priceMin)} - ${Shopify.formatMoney(priceMax)}`;
      }

      // Single price (or only min available)
      return Shopify.formatMoney(priceMin);
    }

    getProductsHtml(products) {
      return `
      <div class="predictive-search__section">
        <ul class="predictive-search__list">
          ${products
            .slice(0, 5)
            .map((product) => this.renderProductListItem(product, false))
            .join('')}
        </ul>
        <a href="/search?q=${encodeURIComponent(this.input.value)}" class="predictive-search__view-all">
          ${this.translations.seeAllProducts}
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M5 12h14m-7-7l7 7-7 7"/>
          </svg>
        </a>
      </div>
    `;
    }

    getCollectionsHtml(collections) {
      return `
      <div class="predictive-search__section">
        <h3 class="predictive-search__heading">${this.translations.collections}</h3>
        <ul class="predictive-search__list">
          ${collections
            .map((collection) => {
              const imageUrl = collection.image || collection.featured_image;
              const collectionUrl = collection.url;

              if (!collectionUrl) {
                console.error('Missing collection URL:', collection);
                return '';
              }

              // Get translated collection title if available
              let displayTitle = collection.title;

              // For Spanish locale, try to get translated collection title
              if (this.currentLocale === 'es' && collection.handle) {
                // Check for common collection translations
                const collectionTranslations = {
                  'paint-acrylic': 'Pintura Acrílica',
                  'paint-oil': 'Pintura al Óleo',
                  'paint-watercolor': 'Acuarela',
                  'paint-airbrush': 'Aerógrafo',
                  'draw-graphite': 'Grafito',
                  'draw-colored-pencil': 'Lápices de Colores',
                  'draw-charcoal-and-chalk': 'Carboncillo y Tiza',
                  'draw-oil-pastels': 'Pasteles al Óleo',
                  'draw-ink': 'Tinta',
                  'draw-markers': 'Marcadores',
                  'craft-adhesives': 'Adhesivos',
                  'craft-scrapbooking': 'Álbumes de Recortes',
                  'craft-glass-and-tile': 'Vidrio y Azulejo',
                  'craft-printmaking': 'Grabado',
                  'craft-textiles-and-dyes': 'Textiles y Tintes',
                  'craft-jewelry': 'Joyería',
                  'sculpt-clay': 'Arcilla',
                  'sculpt-wood': 'Madera',
                  'sculpt-resin-and-molds': 'Resina y Moldes',
                  'play-draw': 'Dibujar',
                  'play-paint': 'Pintar',
                  'play-science-and-nature': 'Ciencia y Naturaleza',
                  'play-crafts': 'Manualidades',
                  'play-book-nook': 'Rincón de Libros',
                  'play-toy-box': 'Caja de Juguetes',
                };

                if (collectionTranslations[collection.handle]) {
                  displayTitle = collectionTranslations[collection.handle];
                }
              }

              return `
              <li class="predictive-search__item">
                <a href="${collectionUrl}" class="predictive-search__link">
                  
                  <div class="predictive-search__item-content">
                    <div class="predictive-search__item-title">${displayTitle}</div>
                  </div>
                </a>
              </li>
            `;
            })
            .join('')}
        </ul>
      </div>
    `;
    }

    getArticlesHtml(articles) {
      return `
      <div class="predictive-search__section">
        <h3 class="predictive-search__heading">${this.translations.articles}</h3>
        <ul class="predictive-search__list">
          ${articles
            .map((article) => {
              const articleUrl = article.url || `/articles/${article.handle}` || article.link;

              if (!articleUrl) {
                console.error('Missing article URL:', article);
                return '';
              }

              return `
              <li class="predictive-search__item">
                <a href="${articleUrl}" class="predictive-search__link">
                  <div class="predictive-search__item-content">
                    <div class="predictive-search__item-title">${article.title}</div>
                  </div>
                </a>
              </li>
            `;
            })
            .join('')}
        </ul>
      </div>
    `;
    }

    getPagesHtml(pages) {
      return `
      <div class="predictive-search__section">
        <h3 class="predictive-search__heading">${this.translations.pages}</h3>
        <ul class="predictive-search__list">
          ${pages
            .map((page) => {
              const pageUrl = page.url || `/pages/${page.handle}` || page.link;

              if (!pageUrl) {
                console.error('Missing page URL:', page);
                return '';
              }

              return `
              <li class="predictive-search__item">
                <a href="${pageUrl}" class="predictive-search__link">
                  <div class="predictive-search__item-content">
                    <div class="predictive-search__item-title">${page.title}</div>
                  </div>
                </a>
              </li>
            `;
            })
            .join('')}
        </ul>
      </div>
    `;
    }
  }

  // Debounce function to limit API calls
  function debounce(fn, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        fn.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  customElements.define('predictive-search', PredictiveSearch);

  // Browser Language Detection and Auto-Redirect System
  function detectAndRedirectLanguage() {
    // Check if user has already made a manual language selection
    const hasManualSelection = localStorage.getItem('manual_language_selection');

    // Check if this is a language change redirect (to prevent loops)
    const isLanguageRedirect = sessionStorage.getItem('language_redirect_performed');

    // Only perform auto-detection on first visit or when no manual selection exists
    if (hasManualSelection || isLanguageRedirect) {
      console.log('[LOCALE] Skipping auto-detection: manual selection exists or redirect already performed');
      return;
    }

    // Get browser language
    const browserLanguage = getBrowserLanguage();
    console.log('[LOCALE] Detected browser language:', browserLanguage);

    // Get current page language
    const currentLocale = document.documentElement.lang || 'en';
    console.log('[LOCALE] Current page locale:', currentLocale);

    // Determine target language
    const targetLanguage = browserLanguage === 'es' ? 'es' : 'en';
    console.log('[LOCALE] Target language:', targetLanguage);

    // Only redirect if we need to change language
    if (currentLocale !== targetLanguage) {
      console.log('[LOCALE] Redirecting to', targetLanguage, 'version');
      redirectToLanguage(targetLanguage);
    } else {
      console.log('[LOCALE] Already on correct language version');
    }
  }

  // Get browser's preferred language
  function getBrowserLanguage() {
    // Check navigator.language and navigator.languages
    const languages = navigator.languages || [navigator.language || navigator.userLanguage];

    console.log('[LOCALE] Browser languages:', languages);

    // Check each language preference
    for (const lang of languages) {
      const langCode = lang.toLowerCase().split('-')[0]; // Get main language code (e.g., 'es' from 'es-MX')

      console.log('[LOCALE] Checking language code:', langCode);

      // Return 'es' if Spanish is detected, otherwise default to 'en'
      if (langCode === 'es') {
        return 'es';
      }
    }

    // Default to English for all other languages
    return 'en';
  }

  // Redirect to appropriate language version
  function redirectToLanguage(targetLanguage) {
    // Mark that we're performing a language redirect
    sessionStorage.setItem('language_redirect_performed', 'true');

    const url = new URL(window.location.href);
    const pathname = url.pathname;

    // Build new URL with correct language prefix
    if (pathname.startsWith('/es/') || pathname.startsWith('/en/')) {
      // Replace existing language prefix
      url.pathname = pathname.replace(/^\/(es|en)\//, `/${targetLanguage}/`);
    } else {
      // Add language prefix to current path
      url.pathname = `/${targetLanguage}${pathname}`;
    }

    console.log('[LOCALE] Redirecting to:', url.toString());
    window.location.href = url.toString();
  }

  // Cookie utilities for language preferences
  function setCookie(name, value, days = 365) {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  // Debug and testing utilities
  window.LanguageDetection = {
    // Reset manual selection to allow auto-detection again
    reset: function () {
      localStorage.removeItem('manual_language_selection');
      sessionStorage.removeItem('language_redirect_performed');
      console.log('[RELOAD] Language detection reset. Reload the page to test auto-detection.');
    },

    // Check current language detection status
    status: function () {
      const browserLang = getBrowserLanguage();
      const currentLang = document.documentElement.lang || 'en';
      const hasManualSelection = localStorage.getItem('manual_language_selection');
      const isRedirectPerformed = sessionStorage.getItem('language_redirect_performed');

      console.log('[LOCALE] Language Detection Status:');
      console.log('  - Browser Language:', browserLang);
      console.log('  - Current Page Language:', currentLang);
      console.log('  - Has Manual Selection:', hasManualSelection ? 'Yes' : 'No');
      console.log('  - Redirect Performed:', isRedirectPerformed ? 'Yes' : 'No');
      console.log('  - Browser Languages:', navigator.languages || [navigator.language]);

      return {
        browserLanguage: browserLang,
        currentLanguage: currentLang,
        hasManualSelection: !!hasManualSelection,
        redirectPerformed: !!isRedirectPerformed,
        browserLanguages: navigator.languages || [navigator.language],
      };
    },

    // Simulate different browser languages for testing
    simulate: function (language) {
      console.log(`[TEST] Simulating browser language: ${language}`);

      // Override the getBrowserLanguage function temporarily
      const originalGetBrowserLanguage = window.getBrowserLanguage;
      window.getBrowserLanguage = function () {
        return language;
      };

      // Reset any previous selections
      this.reset();

      // Wait a bit then run detection
      setTimeout(() => {
        detectAndRedirectLanguage();

        // Restore original function after test
        setTimeout(() => {
          window.getBrowserLanguage = originalGetBrowserLanguage;
        }, 2000);
      }, 100);
    },

    // Force redirect to a specific language (for testing)
    forceRedirect: function (language) {
      console.log(`[REDIRECT] Force redirecting to: ${language}`);
      redirectToLanguage(language);
    },

    // Test auto-detection without redirect
    testDetection: function () {
      const browserLang = getBrowserLanguage();
      const currentLang = document.documentElement.lang || 'en';
      const targetLang = browserLang === 'es' ? 'es' : 'en';

      console.log('[TEST] Test Results:');
      console.log('  - Browser Language:', browserLang);
      console.log('  - Current Language:', currentLang);
      console.log('  - Target Language:', targetLang);
      console.log('  - Would Redirect:', currentLang !== targetLang ? 'Yes' : 'No');

      return {
        browserLanguage: browserLang,
        currentLanguage: currentLang,
        targetLanguage: targetLang,
        wouldRedirect: currentLang !== targetLang,
      };
    },
  };

  // Make getBrowserLanguage available globally for testing
  window.getBrowserLanguage = getBrowserLanguage;

  // Run language detection on page load
  // DISABLED: Do not auto-redirect to /es based on browser language.
  // Main domain (texasart.com) should default to English; Spanish is available via the language switcher.
  document.addEventListener('DOMContentLoaded', function () {
    // detectAndRedirectLanguage(); // Disabled so site defaults to English
    sessionStorage.removeItem('language_redirect_performed');
  });

  // Mobile Menu Toggle
  document.addEventListener('DOMContentLoaded', function () {
    const menuTrigger = document.querySelector('.js-mobile-menu-trigger');
    const langTriggers = document.querySelectorAll('.js-language-trigger');

    if (menuTrigger) {
      menuTrigger.addEventListener('click', function () {
        document.body.classList.toggle('mobile-menu-open');
      });
    }

    if (langTriggers.length > 0) {
      langTriggers.forEach((trigger) => {
        trigger.addEventListener('click', function () {
          // Mark that user made a manual language selection
          localStorage.setItem('manual_language_selection', 'true');

          // Get current locale from HTML tag
          const currentLocale = document.documentElement.lang || 'en';
          const newLocale = currentLocale === 'es' ? 'en' : 'es';

          // Show loading state by adding a class
          trigger.classList.add('language-switching');

          // Get current URL and pathname
          const url = new URL(window.location.href);
          const pathname = url.pathname;

          // If URL already contains locale, replace it; otherwise, add it
          if (pathname.startsWith('/es/') || pathname.startsWith('/en/')) {
            url.pathname = pathname.replace(/^\/(es|en)\//, `/${newLocale}/`);
          } else {
            url.pathname = `/${newLocale}${pathname}`;
          }

          // Navigate to new URL
          window.location.href = url.toString();
        });

        // Add error handling for SVG loading
        const flagImg = trigger.querySelector('.tas-flag-circle img');
        if (flagImg) {
          flagImg.addEventListener('error', function () {
            console.warn('Language flag SVG failed to load:', this.src);
            // Fallback to a text indicator if SVG fails
            const fallbackText = document.createElement('span');
            fallbackText.textContent = document.documentElement.lang === 'es' ? 'EN' : 'ES';
            fallbackText.style.cssText = 'font-size: 12px; font-weight: bold; color: white;';
            this.parentNode.replaceChild(fallbackText, this);
          });

          // Ensure SVG loads properly
          flagImg.addEventListener('load', function () {
            console.log('Language flag SVG loaded successfully:', this.src);
          });
        }
      });
    }
  });

  // Header Scroll Behavior - DOM ready check for CLI 3.x compatibility
  var headerScrollHandler = null; // Track the scroll handler globally
  var isHeaderInitialized = false;

  function initHeaderScrollBehavior() {
    console.log('[HEADER] Initializing header scroll behavior...');

    // Remove old scroll listener if it exists
    if (headerScrollHandler) {
      console.log('[HEADER] Removing old scroll handler...');
      document.removeEventListener('scroll', headerScrollHandler);
      headerScrollHandler = null;
    }

    var lastScrollTop = 0;
    var header = document.querySelector('.tas-header__content');
    var nav = document.querySelector('.tas-nav');
    var body = document.body;
    var scrollThreshold = 100;
    var isTransitioning = false;
    var headerHeight = header ? header.offsetHeight : 0;

    // If elements aren't found, exit early
    if (!header || !nav || !body) {
      console.error('[HEADER ERROR] Cannot initialize - required elements not found!');
      console.error('[HEADER ERROR] Header (.tas-header__content):', !!header);
      console.error('[HEADER ERROR] Nav (.tas-nav):', !!nav);
      console.error('[HEADER ERROR] Body:', !!body);
      return;
    }

    console.log('[HEADER] All elements found, adding at-top class');
    isHeaderInitialized = true;

    // Add at-top class immediately
    console.log('[DEBUG] Current scroll position:', window.pageYOffset);
    console.log('[DEBUG] Body classes before:', body.className);
    body.classList.add('at-top');
    console.log('[DEBUG] Body classes after:', body.className);
    console.log('[DEBUG] Has at-top class?', body.classList.contains('at-top'));

    function handleScroll() {
      // Check if elements still exist in DOM
      if (!document.body.contains(header) || !document.body.contains(nav)) {
        console.warn('[WARNING] Header elements removed from DOM!');
        // Don't reinitialize here to avoid recursion - let section reload handle it
        return;
      }

      var currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      // Check if at the top of the page
      if (currentScroll <= 0) {
        console.log('[AT TOP] At top of page, adding at-top class');
        body.classList.add('at-top');
        header.classList.remove('show-on-scroll-up');
        nav.classList.remove('hide');
        isTransitioning = false;
        return;
      }

      // Don't process if we're in the middle of a transition
      if (isTransitioning) return;

      // Only remove at-top class after scrolling past header height
      if (currentScroll > headerHeight) {
        body.classList.remove('at-top');
      }

      // Scrolling down
      if (currentScroll > lastScrollTop && currentScroll > headerHeight) {
        console.log('[SCROLL DOWN] Scrolling DOWN, hiding header');
        isTransitioning = true;
        requestAnimationFrame(function () {
          header.classList.remove('show-on-scroll-up');
          nav.classList.add('hide');
          body.classList.remove('at-top');
          setTimeout(function () {
            isTransitioning = false;
          }, 150);
        });
      }
      // Scrolling up
      else if (currentScroll < lastScrollTop) {
        if (currentScroll > headerHeight && !isTransitioning) {
          console.log('[SCROLL UP] Scrolling UP, showing header');
          isTransitioning = true;
          requestAnimationFrame(function () {
            header.classList.add('show-on-scroll-up');
            nav.classList.add('hide');
            setTimeout(function () {
              isTransitioning = false;
            }, 150);
          });
        }
      }

      lastScrollTop = currentScroll;
    }

    // Call handleScroll once on page load
    handleScroll();

    // Update headerHeight on window resize
    window.addEventListener('resize', function () {
      headerHeight = header ? header.offsetHeight : 0;
    });

    // Throttle scroll event
    var ticking = false;
    headerScrollHandler = function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    console.log('[SCROLL EVENT] Adding scroll event listener...');
    document.addEventListener('scroll', headerScrollHandler);
  }

  // Execute when DOM is ready - with retry logic for Shopify CLI 3.x
  console.log('[DOM] DOM readyState:', document.readyState);

  // Try to initialize multiple times to handle race conditions
  var initAttempts = 0;
  var maxInitAttempts = 5;

  function tryInitialize() {
    initAttempts++;
    console.log('[INIT] Attempt', initAttempts, 'of', maxInitAttempts);

    var header = document.querySelector('.tas-header__content');
    var nav = document.querySelector('.tas-nav');

    if (header && nav) {
      console.log('[INIT] Elements found! Initializing...');
      initHeaderScrollBehavior();
      return true;
    } else {
      console.log('[INIT] Elements not found yet. Header:', !!header, 'Nav:', !!nav);

      if (initAttempts < maxInitAttempts) {
        console.log('[INIT] Retrying in 100ms...');
        setTimeout(tryInitialize, 100);
      } else {
        console.error('[INIT] Failed to find elements after', maxInitAttempts, 'attempts');
      }
      return false;
    }
  }

  if (document.readyState === 'loading') {
    console.log('[WAITING] Waiting for DOMContentLoaded...');
    document.addEventListener('DOMContentLoaded', function () {
      console.log('[DOM] DOMContentLoaded fired!');
      tryInitialize();
    });
  } else {
    // DOM is already ready, execute immediately
    console.log('[READY] DOM already ready, trying to initialize...');
    tryInitialize();
  }

  // Re-initialize when Shopify sections are reloaded (CLI 3.x hot reload)
  document.addEventListener('shopify:section:load', function (event) {
    var sectionId = event.detail && event.detail.sectionId;
    console.log('[RELOAD] Section reloaded:', sectionId);

    // Only reinitialize if it's a header-related section or if we can't determine the section
    if (!sectionId || sectionId.includes('header') || sectionId.includes('Header')) {
      console.log('[RELOAD] Reinitializing header scroll for section:', sectionId);
      setTimeout(function () {
        initHeaderScrollBehavior();
      }, 100); // Small delay to let DOM update
    }
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    console.log('[RELOAD] Sections reordered, reinitializing header scroll...');
    setTimeout(function () {
      initHeaderScrollBehavior();
    }, 100);
  });

  // Mobile Search Overlay
  document.addEventListener('DOMContentLoaded', function () {
    var searchTrigger = document.querySelector('.js-mobile-search-trigger');
    var searchOverlay = document.querySelector('.tas-mobile-search-overlay');
    var searchClose = document.querySelector('.js-mobile-search-close');
    var searchInput = document.querySelector('.tas-mobile-search-form__input');
    var searchBackdrop = document.querySelector('.tas-mobile-search-overlay__backdrop');

    if (searchTrigger && searchOverlay) {
      searchTrigger.addEventListener('click', function () {
        searchOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        setTimeout(function () {
          if (searchInput) searchInput.focus();
        }, 150);
      });

      var closeSearch = function () {
        searchOverlay.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      if (searchClose) searchClose.addEventListener('click', closeSearch);
      if (searchBackdrop) searchBackdrop.addEventListener('click', closeSearch);

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && searchOverlay.getAttribute('aria-hidden') === 'false') {
          closeSearch();
        }
      });
    }
  });

  console.log('[HEADER] JavaScript block loaded successfully!');
  console.log('[HEADER] Current time:', new Date().toISOString());

  } catch(e) { console.error(e); }
})();
})();
